import React, { useCallback, useRef, useState } from 'react';
import './Contacts.css';
import Recaptcha from 'react-google-invisible-recaptcha';
import TextInput from 'components/TextInput/TextInput';
import Button from 'components/Button/Button';
import Footer from 'components/Footer/Footer';
import { ReactComponent as PhoneIcon } from 'assets/svg/phone.svg';
import { ReactComponent as LocationIcon } from 'assets/svg/location.svg';
import { ReactComponent as MailIcon } from 'assets/svg/mail.svg';
import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';
import { useModal } from 'modules/Modal/ModalProvider';

const valuesDefaultState = {
    customerName: '',
    customerEmail: '',
    message: '',
};

const validationDefaultState = {
    customerName: false,
    customerEmail: false,
    message: false,
};

const RECAPTCHA_SITE_KEY = '6LcmqUIaAAAAAL1w3X7C-Pg2JJluL1A3wi2FsERD';

function Contacts() {
    const [formState, setFormState] = useState(valuesDefaultState);
    const [validationState, setValidationState] = useState(validationDefaultState);
    const recaptchaRef = useRef();

    const { firestore } = useFirebaseProviders();
    const { openAlertModal } = useModal();

    const addEntryToCollection = useCallback(() => {
        firestore
            .collection('messages')
            .add(formState)
            .then(() =>
                openAlertModal(
                    'Thank you for your message. We will contact you as soon as possible.'
                )
            )
            .catch(() => {
                openAlertModal('Oops, something going wrong. Please, try later.');
            });
        setFormState(valuesDefaultState);
    }, [firestore, formState, openAlertModal]);

    const submitHandler = useCallback(() => {
        if (Object.values(validationState).some(v => !v)) {
            recaptchaRef.current.reset();
            return openAlertModal(
                'Oops, there are some errors in the form. Please correct them and retry.'
            );
        }
        recaptchaRef.current.execute();
    }, [openAlertModal, validationState]);

    return (
        <section className={'contacts rounds-bg'}>
            <div className={'contacts-content'}>
                <div className={'contacts__contacts-info'} data-aos={'fade-right'}>
                    <h3>Contact Us</h3>
                    <br />
                    <ul />
                    <li>We located in Menno, SD. We are 1 hour from Sioux Falls, SD;</li>
                    <li>1,5 hours from Sioux City, IA;</li>
                    <li>3 hours from Omaha, NE. All three have major airports.</li>
                    <ul />
                    <br />
                    <p>
                        We'd love to get in touch with you! Send us a message below and we'll
                        contact you in the next 24 hours. Thanks!
                    </p>
                    <div className={'contacts__info-row'}>
                        <MailIcon />
                        <a href="mailto:mypianobabe@yahoo.com">mypianobabe@yahoo.com</a>
                    </div>
                    <div className={'contacts__info-row'}>
                        <PhoneIcon />
                        <a href="sms:6053875250">text to (605)660-7878</a>
                    </div>
                    <div className={'contacts__info-row'}>
                        <LocationIcon />
                        <p>Menno SD 57045</p>
                    </div>
                </div>
                <div className={'contacts__contacts-message'} data-aos={'fade-left'}>
                    <h3>Say Something</h3>
                    <TextInput
                        label={'Your Name'}
                        placeholder={'Name'}
                        onChange={({ value, valid }) => {
                            setFormState({ ...formState, customerName: value });
                            setValidationState({ ...validationState, customerName: valid });
                        }}
                        value={formState.customerName}
                        valid={validationState.customerName}
                        validationRegExp={/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g}
                    />
                    <TextInput
                        label={'Your Email'}
                        placeholder={'email@domain.com'}
                        onChange={({ value, valid }) => {
                            setFormState({ ...formState, customerEmail: value });
                            setValidationState({ ...validationState, customerEmail: valid });
                        }}
                        value={formState.customerEmail}
                        valid={validationState.customerEmail}
                        validationRegExp={/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g}
                    />
                    <TextInput
                        label={'Message'}
                        placeholder={'Message...'}
                        onChange={({ value, valid }) => {
                            setFormState({ ...formState, message: value });
                            setValidationState({ ...validationState, message: valid });
                        }}
                        value={formState.message}
                        valid={validationState.message}
                        multiline
                    />
                    <Button label={'Send'} onClick={submitHandler} />
                </div>
            </div>
            <Footer />
            <Recaptcha
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                onResolved={addEntryToCollection}
            />
        </section>
    );
}

export default Contacts;
